import { render, staticRenderFns } from "./base-pay.vue?vue&type=template&id=38f0cede"
import script from "./base-pay.vue?vue&type=script&lang=js"
export * from "./base-pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports